import React from 'react';
import { HeroUIProvider } from '@heroui/react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { StompProvider } from './contexts/StompContext';
import { NotificationProvider } from './contexts/NotificationContext';
import Layout from './components/Layout/Layout';
import './App.css';

function App() {
  return (
    <HeroUIProvider>
      <Router>
        <AuthProvider>
          <StompProvider>
            <NotificationProvider>
              <div className="App">
                <Layout />
              </div>
            </NotificationProvider>
          </StompProvider>
        </AuthProvider>
      </Router>
    </HeroUIProvider>
  );
}

export default App;
